const LandingAboutUsCounter = ({years, tag}) => {
    return (
        <div className="text-left">
            <p className="text-5xl text-accent font-bold">{years}+</p>
            <p className="mt-2">{tag}</p>
        </div>
    )
}

export default LandingAboutUsCounter